import React from "react";
import { withStyles } from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import { School as SchoolIcon } from "@material-ui/icons";
import Tooltip from '@material-ui/core/Tooltip';
import {
  URL_REVIEW_ATTENDANCES,  
  AT_REASON_ID_NOT_SET,
  ID_ZERO,
  SYNC_STATE_ERROR,
  SYNC_STATE_NEEDS_SYNC,
  SYNC_STATE_NEEDS_DELETE,
  SYNC_STATE_NOT_SYNCABLE,
  SYNC_STATE_SYNCED_BOTH,
  SYNC_STATE_SYNCED_PUSH,
  SYNC_STATE_SYNCED_PULL,
  SYNC_STATE_SYNCING,
  AT_RECORD_CREATED_WITH_ADMIN,
  AT_RECORD_CREATED_WITH_AT_MONITOR,
  AT_RECORD_CREATED_WITH_KIOSK,
  AT_RECORD_CREATED_WITH_Q,
  AT_RECORD_CREATED_WITH_OUT_PROPAGATION,
  URL_MANAGE_STUDENT_DETAIL,
  SEARCH_CONTEXT_REVIEW_ATTENDANCES
} from "redux/constants";
import styles from './styles';
import {getAtTypeCellStyle, getAtTypeTextStyle} from './styles';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import Typography from "@material-ui/core/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckCircle, ErrorOutline, Sync } from "@material-ui/icons";
import {
  atRecordEdit,
  approveAttendances,
  startAttendanceReviewDataPoll,
  stopAttendanceReviewDataPoll,
  fetchReviewAttendancesResponse
} from 'redux/admin/Actions'
import AtRecordEditor from "apps/admin/components/AtRecordEditor"
import AtRecord from "common/model/AtRecord";
import moment from 'moment-timezone'
import { pageLink } from 'apps/admin/components/Link'

const syncStateDisplayMap = {
  [SYNC_STATE_ERROR]: 'Sync error',
  [SYNC_STATE_NEEDS_SYNC]: 'Sync scheduled',
  [SYNC_STATE_NEEDS_DELETE]: 'Sync scheduled',
  [SYNC_STATE_NOT_SYNCABLE]: 'Not Syncable',
  [SYNC_STATE_SYNCED_BOTH]: 'Synced',
  [SYNC_STATE_SYNCED_PUSH]: 'Synced',
  [SYNC_STATE_SYNCED_PULL]: 'Synced',
  [SYNC_STATE_SYNCING]: 'Sync scheduled',
}

const syncedSyncStates = [
  SYNC_STATE_SYNCED_BOTH,
  SYNC_STATE_SYNCED_PUSH,
  SYNC_STATE_SYNCED_PULL,
  SYNC_STATE_ERROR,
  SYNC_STATE_NOT_SYNCABLE
]

const getSourceDisplay = (periodData) => {
  if (!periodData.attendanceCreatedWith) return ''

  switch (periodData.attendanceCreatedWith) {
    case AT_RECORD_CREATED_WITH_ADMIN:
      return 'Admin'
    case AT_RECORD_CREATED_WITH_KIOSK:
      return 'Student Check-in'
    case AT_RECORD_CREATED_WITH_Q:
      return 'Skyward'
    case AT_RECORD_CREATED_WITH_AT_MONITOR:
      return 'Monitor'
    case AT_RECORD_CREATED_WITH_OUT_PROPAGATION:
      return 'Out Propagation'
    default:
      return ''
  }
}

const getLocationDisplay = (periodData) => {
  if (!periodData.isDifferentAtRecordCourse && (!periodData.location || periodData.location.id == ID_ZERO)) {
    return ''
  }

  if (periodData.isDifferentAtRecordCourse && (!periodData.location || periodData.location.id == ID_ZERO)) {
    return `Not Set (${periodData.atRecordRegisteredCourse})`
  } 

  let result = periodData.location.displayName
  if (periodData.isDifferentAtRecordCourse && periodData.atRecordRegisteredCourse) {
    result += ` (${periodData.atRecordRegisteredCourse})`
  }

  return result
}


const getSyncStateDisplay = (periodData) => {
  if (periodData.isTeacherApproved || syncedSyncStates.includes(periodData.syncState)) {
    return syncStateDisplayMap[periodData.syncState] || 'Unknown'
  }
  return "Pending approval"
}

const getSyncStateIcon = (formattedSyncState) => {
  switch (formattedSyncState) {
    case 'Sync error':
      return <ErrorOutline style={{ color: "#e53935", fontSize: 18 }} />
    case 'Sync scheduled':
      return <Sync style={{ color: "#1976d2", fontSize: 18 }} />
    case 'Not Syncable':
      return <CheckCircle style={{ color: "#D3D3D3", fontSize: 18 }} />
    case 'Synced':
      return <CheckCircle style={{ color: "#43a047", fontSize: 18 }} />
    default:
      return null;
  }
}

class ReviewAttendances extends React.Component {
  state = {
    activeTab: 0,
  };

  componentDidMount() {
    if (!this._reviewDataPollStarted) {
      this._reviewDataPollStarted = true
      this.props.startAttendanceReviewDataPoll({msPolling:5000})
    }
  }

  componentWillUnmount() {
    if (this._reviewDataPollStarted) {
      this.props.stopAttendanceReviewDataPoll()
      this._reviewDataPollStarted = false
      this.props.fetchReviewAttendancesResponse(false)
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  handleUpdate = ({ propertyName, val }) => {
    this.setState({ [propertyName]: val });
  };

  navigateToStudentDetails = (studentId, studentFacilityId) => {
    let facilityId = this.props.currentFacilityId || studentFacilityId
    this.props.history.push(pageLink(URL_MANAGE_STUDENT_DETAIL, facilityId, studentId));
  };

  render() {
    const { classes, reviewData, atRecordEdit, facilityIdsWithAttendanceApproveRequired } = this.props;

    const { activeTab } = this.state;
    const periods = (reviewData && reviewData.schedulePeriods) || [];
    const notScheduled = (reviewData && reviewData.notScheduledCheckins) || [];

    return (
      reviewData ? (
        <div className={classes.root}>
          <AtRecordEditor/>
          <Typography
            variant="h6"
            component="div"
            style={{ marginBottom: 16, paddingLeft: 24 }}
            className={classes.sessionTime}
          >
            <div>
              {reviewData.date} {reviewData.dayOfWeek}
            </div>
            <div>
              {reviewData.displayCode} {reviewData.courseName} ({reviewData.sectionName})
            </div>
            <div>
              Location: {reviewData.scheduledLocationName}
            </div>
          </Typography>
          <Tabs
            value={activeTab}
            onChange={this.handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab
              style={{
                maxWidth: '1000px'
              }}
              label={
                <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                    Scheduled Students
                  </Typography>
                  <Badge
                    badgeContent={`${reviewData.checkedInStudentNumber}/${reviewData.sectionScheduledStudentNumber}`}
                    color="primary"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    style={{ marginLeft: 15 }}
                  />
                </span>
              }
            />
            {reviewData.scheduledLocationId !== ID_ZERO && notScheduled.length > 0 && (
              <Tooltip title="Student check-ins recorded during class but not scheduled for it" placement="top">
                <Tab
                  style={{
                    maxWidth: '1000px'
                  }}
                  label={
                    <span style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      maxWidth: 220
                    }}>
                      <Typography variant="subtitle1" style={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                        Not scheduled entries
                      </Typography>
                      <Badge
                        badgeContent={reviewData.notScheduledCheckinNumber}
                        color="primary"
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        style={{ marginLeft: 10 }}
                      />
                    </span>
                  }
                />
              </Tooltip>
            )}
          </Tabs>
          <div style={{ marginTop: 24 }}>
            {activeTab === 0 && (
              <div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Student Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Registered Time
                        </Typography>
                      </TableCell>                   
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Type
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Reason
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Notes
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Location
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Actions
                        </Typography>
                      </TableCell>
                      {facilityIdsWithAttendanceApproveRequired.includes(reviewData.facilityId) && (
                        <TableCell>
                          <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                            Teacher Approved
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Sync State
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <tbody>
                    {periods.map(p => (
                      <TableRow key={p.id}>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText} onClick={() => this.navigateToStudentDetails(p.studentId, p.studentFacilityId)} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                            {p.studentName}
                          </Typography>
                        </TableCell>
                       <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            <span style={{ display: 'inline-block', whiteSpace: 'nowrap', marginRight: 7, fontWeight: 600 }}>
                              {getSourceDisplay(p) || ''}
                            </span>
                            <span style={{ display: 'inline-block', whiteSpace: 'nowrap', marginRight: 7 }}>
                              {p.atRecordUTime ? moment.unix(p.atRecordUTime).format('h:mm:ss A') : ''}
                            </span>
                          </Typography>
                        </TableCell>
                        <TableCell style={p.atType ? getAtTypeCellStyle(p.atType.id) : {}}>
                          <Typography variant="body2" style={p.atType ? getAtTypeTextStyle(p.atType.id) : { }} className={classes.tableCellText}>
                            {p.atType ? p.atType.displayName : ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {p.atReason && p.atReason.id != AT_REASON_ID_NOT_SET ? p.atReason.displayName : ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {p.notes || ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {getLocationDisplay(p)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: "flex", width: "100%" }}>
                            {p.atType ? (
                              <>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  style={{
                                    flex: 1,
                                    marginRight: 8,
                                    backgroundColor: "#E3F2FD",
                                    color: "#1976d2",
                                    boxShadow: "none"
                                  }}
                                  onClick={() => {
                                    if (p.isLocked) return
                                    atRecordEdit({
                                      studentName: p.studentName,
                                      atRecord: p.atRecord,
                                      periodNumber: p.periodNumber,
                                      atRecordSaveActionName: 'reviewAtRecordEditSave',
                                      atRecordDeleteActionName: 'reviewAtRecordDelete'
                                  })}}
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  style={{
                                    flex: 1,
                                    backgroundColor: "#E8F5E9",
                                    color: "#388e3c",
                                    boxShadow: "none"
                                  }}
                                  onClick={() => {
                                    if (p.isLocked) return
                                    atRecordEdit({studentName: p.studentName, atRecord:
                                      AtRecord({
                                        atUserId: p.studentId,
                                        facilityId: p.facilityId,
                                        atUserSchedulePeriodId: p.id,
                                        uTime: p.uStart
                                      }),
                                      periodNumber: p.periodNumber,
                                      atRecordSaveActionName: 'reviewAtRecordEditSave',
                                      atRecordDeleteActionName: 'reviewAtRecordDelete'
                                  })}}
                                >
                                  Create
                                </Button>
                              </>
                            ) : (
                              <Button
                                size="small"
                                variant="outlined"
                                fullWidth
                                style={{
                                  backgroundColor: "#E8F5E9",
                                  color: "#388e3c",
                                  boxShadow: "none"
                                }}
                                onClick={() => {
                                  if (p.isLocked) return
                                  atRecordEdit({studentName: p.studentName, atRecord:
                                    AtRecord({
                                      atUserId: p.studentId,
                                      facilityId: p.facilityId,
                                      atUserSchedulePeriodId: p.id,
                                      uTime: p.uStart
                                    }),
                                    periodNumber: p.periodNumber,
                                    atRecordSaveActionName: 'reviewAtRecordEditSave',
                                    atRecordDeleteActionName: 'reviewAtRecordDelete'
                                })}}
                              >
                                Create
                              </Button>
                            )}
                          </div>
                        </TableCell>
                        {facilityIdsWithAttendanceApproveRequired.includes(reviewData.facilityId) && (
                          <TableCell>
                            {p.atType && p.isTeacherApproved && (
                              p.attendanceCreatedWith === AT_RECORD_CREATED_WITH_ADMIN ? (
                                <Tooltip title="Records created by admin are automatically approved." placement="top">
                                  <span>
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      disabled
                                      style={{
                                        backgroundColor: "#e0e0e0",
                                        color: "#757575",
                                        boxShadow: "none",
                                        minWidth: 120
                                      }}
                                    >
                                      <CheckIcon style={{ fontSize: 18, marginRight: 6 }} />
                                      Approved
                                    </Button>
                                  </span>
                                </Tooltip>
                              ) : (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  disabled
                                  style={{
                                    backgroundColor: "#e0e0e0",
                                    color: "#757575",
                                    boxShadow: "none",
                                    minWidth: 120
                                  }}
                                >
                                  <CheckIcon style={{ fontSize: 18, marginRight: 6 }} />
                                  Approved
                                </Button>
                              )
                            )}
                            {p.atType && !p.isTeacherApproved && (
                              <Button
                                size="small"
                                variant="outlined"
                                style={{
                                  backgroundColor: "#E3F2FD",
                                  color: "#1976d2",
                                  boxShadow: "none",
                                  minWidth: 120
                                }}
                                onClick={() => this.props.approveAttendances([p.atRecord.id])}
                              >
                                Approve
                              </Button>
                            )}
                          </TableCell>
                        )}
                        <TableCell>
                          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            {getSyncStateIcon(getSyncStateDisplay(p))}
                            <Typography variant="body2" className={classes.tableCellText}>
                              {p.atType && getSyncStateDisplay(p)}
                            </Typography>
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell colSpan={6} />
                      <TableCell>
                        <Button
                          size="small"
                          variant="outlined"
                          fullWidth
                          style={{
                            backgroundColor: "#F0F4C3",
                            color: "#388e3c",
                            boxShadow: "none",
                            marginRight: 8
                          }}
                          onClick={() => {
                            atRecordEdit({studentName: "Absent students", atRecord:
                              AtRecord({
                                facilityId: reviewData.facilityId,
                              }),
                              periodNumber: reviewData.displayCode,
                              atRecordSaveActionName: 'createAtRecordForAbsentStudents',
                              atRecordDeleteActionName: 'reviewAtRecordDelete'
                          })}}
                        >
                          Create for all without records
                        </Button>
                      </TableCell>
                      {facilityIdsWithAttendanceApproveRequired.includes(reviewData.facilityId) && (
                        <TableCell>
                          <Button
                            size="small"
                            variant="outlined"
                            style={{
                              backgroundColor: "#D1C4E9",
                              color: "#fff",
                              boxShadow: "none",
                              minWidth: 120
                            }}
                            disabled={!(reviewData.notApprovedAtRecordIds && reviewData.notApprovedAtRecordIds.length)}
                            onClick={() => this.props.approveAttendances(reviewData.notApprovedAtRecordIds)}
                          >
                            Approve all
                          </Button>
                        </TableCell>
                      )}
                      <TableCell />
                    </TableRow>
                  </tbody>
                </Table>
              </div>
            )}
            {activeTab === 1 && (
              <div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Student Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Type
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Reason
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Attendance Notes
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Scheduled Period Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Scheduled Location
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
                          Scheduled Teacher
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <tbody>
                    {notScheduled.map((ns, idx) => (
                      <TableRow key={ns.id || ns.studentId || idx}>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText} onClick={() => this.navigateToStudentDetails(ns.studentId, ns.studentFacilityId)} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                            {ns.studentName || ''}
                          </Typography>
                        </TableCell>
                        <TableCell style={ns.atType ? getAtTypeCellStyle(ns.atType.id) : {}}>
                          <Typography variant="body2" className={classes.tableCellText} style={ns.atType ? getAtTypeTextStyle(ns.atType.id) : { color: 'inherit' }}>
                            {ns.atType ? ns.atType.displayName : ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {ns.atReason && ns.atReason.id != AT_REASON_ID_NOT_SET ? ns.atReason.displayName : ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {ns.notes || ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {ns.scheduledPeriodName || ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {ns.scheduledLocationName || ''}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" className={classes.tableCellText}>
                            {ns.scheduledTeacherName || ''}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </tbody>
                </Table>
              </div>
             )}
          </div>
        </div>
      ) : (
        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <CircularProgress />
        </div>
      )
    );
  }
}

const mapStateToProps = state => {
  return { ...state.admin.attendanceReview, currentItemId: state.admin.currentItemId, facilityIdsWithAttendanceApproveRequired: state.admin.facilityIdsWithAttendanceApproveRequired };
}

const mapDispatchToProps = {
  atRecordEdit,
  approveAttendances,
  startAttendanceReviewDataPoll,
  stopAttendanceReviewDataPoll,
  fetchReviewAttendancesResponse
};

export const ReviewAttendancesPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ReviewAttendances));


export const reviewAttendancesPage = {
  searchContext: SEARCH_CONTEXT_REVIEW_ATTENDANCES,
  searchOnPathChange:true,
  icon: SchoolIcon,
  component: ReviewAttendancesPage,
  name: "Attendance Review",
  displayName: "Attendance Review",
  to: URL_REVIEW_ATTENDANCES,
};

export default ReviewAttendancesPage;